import React, { useCallback, useState } from 'react'
import clsx from 'clsx'

import { EditorProps } from '../../../types'
import defaultParser from '../../../utils/numberParser'
import { TAB_KEY, ENTER_KEY, ESC_KEY } from '../../../utils/keys'

export interface Props extends EditorProps<number> {
  parser: (value: string) => number
  className?: string
  style?: React.CSSProperties
}

const NumberEditor: React.FC<Props> = ({
  value,
  onChange,
  parser,
  className,
  style,
}) => {
  const [inputValue, setInputValue] = useState(value ? value.toString() : '')

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setInputValue(event.target.value)
    },
    [],
  )

  const handleBlur = useCallback(() => {
    onChange(parser(inputValue))
  }, [inputValue, onChange, parser])

  const handleKeyDown = useCallback(
    ({ keyCode }: React.KeyboardEvent<HTMLInputElement>) => {
      if (keyCode === TAB_KEY || keyCode === ESC_KEY || keyCode === ENTER_KEY) {
        handleBlur()
      }
    },
    [handleBlur],
  )

  return (
    <input
      data-testid="number-editor-input"
      autoFocus
      className={clsx(
        'w-full h-full text-sm focus:outline-none bg-transparent',
        className,
      )}
      style={style}
      value={inputValue}
      onBlur={handleBlur}
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  )
}

export default NumberEditor

NumberEditor.defaultProps = {
  parser: defaultParser,
}
